var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,3a9,9,0,0,0-9,9H1l3.89,3.89L5,16l4-4H6a7,7,0,1,1,2.06,4.94L6.64,18.36A9,9,0,1,0,13,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.12,15.06c-1.24,0-1.72-.55-1.79-1.26H10a2.52,2.52,0,0,0,2.21,2.3v1.31H14V16.12c1.17-.23,2.1-.9,2.1-2.13,0-1.71-1.46-2.29-2.82-2.64s-1.8-.72-1.8-1.29S12.11,9,13.12,9s1.46.51,1.5,1.26H16A2.4,2.4,0,0,0,14,7.92V6.6h-1.8V7.9a2.35,2.35,0,0,0-2.1,2.17c0,1.38,1.15,2.07,2.82,2.47,1.5.36,1.8.89,1.8,1.45C14.74,14.4,14.44,15.06,13.12,15.06Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.25ddf46c.svg";
export { ForwardRef as ReactComponent };